import { useState, useEffect, useCallback } from 'react'
import { useCountdownFSBonusStore } from '@stores/countdownFSBonusStore'
import { useFreeBuyBonusStore } from '@stores/freeBuyBonusStore'
import { useFreeSpinsBonusesStore } from '@stores/freeSpinsBonusesStore'
import { BonusSystemState, GameUIMessageType } from 'game-ui-types'

export const useBonusModalClose = () => {
    const [isClosingModalsRequested, setIsClosingModalsRequested] = useState(false)
    const [areModalsClosed, setAreModalsClosed] = useState(false)

    const isFSBonusModalOpen = useFreeSpinsBonusesStore((s) => s.isModalOpened)
    const isFBBModalOpen = useFreeBuyBonusStore((s) => s.isModalOpened)
    const isCFSModalOpen = useCountdownFSBonusStore((s) => s.isModalOpened)
    const activeBonus = useCountdownFSBonusStore((s) => s.activeBonus)

    const setFSShowRemainingSpinsBanner = useFreeSpinsBonusesStore((state) => state.setShowRemainingSpinsBanner)
    const setFSBonusSystemState = useFreeSpinsBonusesStore((state) => state.setBonusSystemState)
    const setCFSActiveBonus = useCountdownFSBonusStore((state) => state.setActiveBonus)
    const setCFSBonusSystemState = useCountdownFSBonusStore((state) => state.setBonusSystemState)
    const setFBBonusSystemState = useFreeBuyBonusStore((state) => state.setBonusSystemState)

    const requestCloseModals = useCallback(() => {
        setAreModalsClosed(false)
        setIsClosingModalsRequested(true)
    }, [])

    useEffect(() => {
        if (!isClosingModalsRequested) return

        if (isFSBonusModalOpen || isFBBModalOpen) {
            if (isFBBModalOpen) {
                setFBBonusSystemState(BonusSystemState.INACTIVE)
            } else {
                setFSShowRemainingSpinsBanner(false)
                setFSBonusSystemState(BonusSystemState.INACTIVE)
            }

            window.uiBus.postMessage({
                type: GameUIMessageType.FREESPIN_BONUS_END_MODAL_BUTTON_CLICKED,
            })
        } else if (isCFSModalOpen) {
            setCFSActiveBonus(undefined)
            setCFSBonusSystemState(BonusSystemState.INACTIVE)

            window.uiBus.postMessage({
                type: GameUIMessageType.COUNTDOWN_FS_BONUS_END_MODAL_BUTTON_CLICKED,
                bonusId: activeBonus?.id ?? '',
            })
        }
    }, [isClosingModalsRequested, isFSBonusModalOpen, isFBBModalOpen, isCFSModalOpen, activeBonus])

    useEffect(() => {
        if (!isClosingModalsRequested) return

        const areModalsActuallyInactive = !isFSBonusModalOpen && !isFBBModalOpen && !isCFSModalOpen

        if (areModalsActuallyInactive) {
            setAreModalsClosed(true)
            setIsClosingModalsRequested(false)
        }
    }, [isClosingModalsRequested, isFSBonusModalOpen, isFBBModalOpen, isCFSModalOpen])

    return {
        isClosingModalsRequested,
        setIsClosingModalsRequested,
        areModalsClosed,
        setAreModalsClosed,
        requestCloseModals,
    }
}
